import AbstractWizardStep from "./AbstractWizardStep.js";
import FormBuilder from "../widgets/forms/FormBuilder.js";

/**
 * `AbstractFormStep` is a wizard step rendering a form and
 * submitting the form when the step is submitted.
 *
 * @param {Renderable} spec.instructions - Optionnal details about the step.
 */
export default class AbstractFormStep extends AbstractWizardStep {
	constructor({ instructions }) {
		super(...arguments);

		this._instructions = instructions;
		this._form = undefined;
	}

	getRenderable() {
		return this._form;
	}

	_isCompleted() {
		return this._form.isValid();
	}

	_doSubmit(...rest) {
		if (!this._shouldSubmitOnStart()) this._form.submit();

		super._doSubmit(...rest);
	}

	_doStart() {
		this._initializeForm();
	}

	_initializeForm() {
		this._createForm();

		if (this._instructions) {
			this._addInstructions(this._form);
		}

		this._populateForm(this._form);
	}

	_addInstructions(form) {
		form.append((html) =>
			html.div(
				{ klass: "form-group" },
				html.h3({ klass: "col-sm-12" }, this._instructions),
			),
		);
	}

	_createForm() {
		this._form = new FormBuilder({
			showActions: false,
			model: this._context,
			labelClass: "col-sm-3",
			inputClass: "col-sm-9",
		});
	}

	_populateForm(_form) {
		throw new Error("Subclass responsibility");
	}
}
